import { createResource, type RouteResource } from '@atlassian/react-resource-router';

/**
 * SSR route resource resolving whether the current user holds the JSM admin role (`ADMINISTER_JSM`)
 * from the AGG `hasJsmAdminAccess` field. Tenant scoped (keyed by `cloudId`) and gated by
 * `enable_jsm_admin`; resolves to `false` for Jira admins and when the gate is off.
 */
export const jsmAdminPermissionResource: RouteResource<boolean> = createResource<boolean>({
	type: 'JSM_ADMIN_PERMISSION',
	getKey: (_routerContext, { tenantContext }) => tenantContext?.cloudId ?? '',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-jsm-admin-permission" */ './jsmAdminPermissionData.tsx'
		),
	maxAge: 5 * 60 * 1000,
	isPageShellCritical: true,
});
